import React, { useEffect, useState, useMemo, useRef, useCallback } from "react";
// ⭐️ CAMBIO 1: Importar doc, getDoc, updateDoc, arrayUnion, QUERY y WHERE
import { FIRESTORE_DB } from "../../Database/Database";
import { collection, getDocs, doc, getDoc, updateDoc, arrayUnion, query, where } from "firebase/firestore"; 
import { NavBarDashboard } from "../../Components/NavBarDashboard/NavBarDashboard";
import { FooterDashboard } from "../../Components/FooterDashboard/FooterDashboard";

import { Container, Row, Col, Card, Button, Spinner, Form, Alert } from "react-bootstrap";

import { BuscadorProductos } from "./components/BuscadorProductos";
import { ListaProductos } from "./components/ListaProductos";
import { Carrito } from "./components/Carrito";
import { MetodoPago } from "./components/MetodoPago";
import { TicketA4, Ticket58mm } from "./components/TicketA4";
import { AtajosPOS } from "./components/AtajosPOS";

import { generarIDTicket } from "./helpers/generarIDTicket";
import { registrarVenta } from "./api/ventas";
import CrearProducto from "../Dashboard/CrearProducto/CrearProducto";
import CalculadoraEfectivoModal from "./components/CalculadoraEfectivoModal";

const Ventas = () => {

  //estados para crear productos
 const [showCrearProducto, setShowCrearProducto] = useState(false);

//estado calculadora descuentos
const [showCalcEfectivo, setShowCalcEfectivo] = useState(false);



  const [productos, setProductos] = useState([]);
  const [filtros, setFiltros] = useState({ codigo: "", categoria: "", proveedor: "", nombre: "" });
  const [carrito, setCarrito] = useState([]);

  // ⭐️ CAMBIO: Nuevo estado para array de pagos (múltiples)
  const [pagos, setPagos] = useState([]);
  // const [metodoPago, setMetodoPago] = useState("efectivo"); // Eliminado

  const [descuentoAplicado, setDescuentoAplicado] = useState(0);

  // 🔹 ESTADOS PROMO
  const [promoDescuento, setPromoDescuento] = useState(0); // porcentaje
  const [motivoPromo, setMotivoPromo] = useState("");

  const [cliente, setCliente] = useState("");
  const [estado, setEstado] = useState("completada");

  const [loading, setLoading] = useState(false);
  const [ticketToPrint, setTicketToPrint] = useState(null);

  const buscadorRef = useRef(null);

  // 🔹 NUEVOS ESTADOS NOTA DE CRÉDITO
  const [ncIDIngresado, setNcIDIngresado] = useState("");
  const [notaCreditoActiva, setNotaCreditoActiva] = useState(null); // Objeto NC fetched
  const [errorNC, setErrorNC] = useState(null);

  const loadProductos = async () => {
    try {
      const snap = await getDocs(collection(FIRESTORE_DB, "productos"));
      const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setProductos(list);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadProductos();
  }, []);

  const categorias = useMemo(() => {
    const s = new Set();
    productos.forEach(p => p.categoria && s.add(p.categoria));
    return Array.from(s);
  }, [productos]);

  const proveedores = useMemo(() => {
    const s = new Set();
    productos.forEach(p => p.proveedor && s.add(p.proveedor));
    return Array.from(s);
  }, [productos]);

  const productosFiltrados = useMemo(() => {
    return productos.filter(p => {
      if (filtros.codigo && !(String(p.codigoProducto || "").toLowerCase().includes(filtros.codigo.toLowerCase()))) return false;
      if (filtros.categoria && p.categoria !== filtros.categoria) return false;
      if (filtros.proveedor && p.proveedor !== filtros.proveedor) return false;
      if (filtros.nombre && !(String(p.nombreProducto || "").toLowerCase().includes(filtros.nombre.toLowerCase()))) return false;
      return true;
    });
  }, [productos, filtros]);

  const agregarAlCarrito = (prod) => {
    const exists = carrito.find(p => p.id === prod.id);
    if (exists) {
      setCarrito(carrito.map(p => p.id === prod.id ? { ...p, cantidad: p.cantidad + 1 } : p));
    } else {
      setCarrito([...carrito, { ...prod, cantidad: 1 }]);
    }
  };

  const cambiarCantidad = (id, cantidad) => {
    if (cantidad <= 0) return;
    setCarrito(carrito.map(p => p.id === id ? { ...p, cantidad } : p));
  };

  const quitarDelCarrito = (id) => {
    setCarrito(carrito.filter(p => p.id !== id));
  };

  const limpiarFiltros = () => setFiltros({ codigo: "", categoria: "", proveedor: "", nombre: "" });

  const limpiarCarrito = () => {
    setCarrito([]);
    setTicketToPrint(null);
    setCliente("");
    setDescuentoAplicado(0);
    setPromoDescuento(0);
    setMotivoPromo("");
    
    // ⭐️ CAMBIO: Limpiar array de pagos
    setPagos([]); 
    
    // ⭐️ Limpiar estado de NC
    setNcIDIngresado("");
    setNotaCreditoActiva(null);
    setErrorNC(null);
  };

  const totalSinDescuento = carrito.reduce(
    (s, it) => s + (Number(it.precioFinal || 0) * it.cantidad),
    0
  );

  const gananciaBruta = carrito.reduce((s, it) => {
    const costo = Number(it.precioCosto || 0);
    const precioUnit = Number(it.precioFinal || 0);
    return s + ((precioUnit - costo) * it.cantidad);
  }, 0);

  // 🔹 TOTAL BRUTO (Antes de aplicar NC)
  const totalFinalBruto = Math.max(
    0,
    totalSinDescuento - (descuentoAplicado || 0) - Math.round(totalSinDescuento * ((promoDescuento || 0) / 100))
  );

  // 🔹 CÁLCULO DE MONTO DE NC A APLICAR
  const montoNCUsado = useMemo(() => {
    if (!notaCreditoActiva) return 0;
    // El monto a usar es el mínimo entre:
    // 1. El total de la venta (bruto)
    // 2. El saldo restante de la Nota de Crédito
    return Math.min(totalFinalBruto, notaCreditoActiva.montoRestante);
  }, [notaCreditoActiva, totalFinalBruto]);

  // ⭐️ NUEVO: Determinar si se usó una Nota de Crédito
  const isNcUsed = montoNCUsado > 0;
  
  // 🔹 TOTAL FINAL (Monto DUE: Bruto - Monto NC Aplicado)
  const totalFinal = Math.max(0, totalFinalBruto - montoNCUsado);

  // ⭐️ NUEVO: Calcular el monto total pagado en medios de pago (efectivo, tarjeta, etc.)
  const totalPagadoPorMetodos = pagos.reduce((sum, p) => sum + Number(p.monto || 0), 0);
  // ⭐️ NUEVO: Calcular el saldo pendiente (el que DEBERÍA ser 0 al finalizar)
  // ⭐️ Aumento de tolerancia para evitar problemas de coma flotante.
  const saldoPendienteAPagar = Math.max(0, totalFinal - totalPagadoPorMetodos);


  // 💥 LOGICA NOTA DE CRÉDITO: Función de consulta
  const consultarNotaCredito = useCallback(async (id) => {
    setNotaCreditoActiva(null);
    setErrorNC(null);
    if (!id || id.length < 5) return; 

    let ncSnap = null;
    const ncCollection = collection(FIRESTORE_DB, "notasCredito");
    
    // 1. Intentar buscar por el ID PRÁCTICO (numeroNC)
    try {
        const q = query(ncCollection, where("numeroNC", "==", id));
        const qSnapshot = await getDocs(q);
        
        if (!qSnapshot.empty) {
            ncSnap = qSnapshot.docs[0]; // Tomar el primer resultado
        }
    } catch (e) {
        console.warn("Error searching by numeroNC:", e);
    }
    
    // 2. Si no se encontró por numeroNC, intentar buscar por el ID de Firestore (id)
    if (!ncSnap) {
        try {
            const ncRef = doc(FIRESTORE_DB, "notasCredito", id);
            const directSnap = await getDoc(ncRef);
            if (directSnap.exists()) {
                 ncSnap = directSnap;
            }
        } catch (e) {
            console.warn("Error searching by Firestore ID:", e);
        }
    }

    if (!ncSnap) {
        setErrorNC("ID/N° de Nota de Crédito no encontrado.");
        return;
    }

    // Continuar con la validación de la NC
    const ncData = { id: ncSnap.id, ...ncSnap.data() };
    
    if (ncData.montoRestante <= 0 || ncData.estado === 'usada') {
        // Usar el número práctico o el ID largo para el mensaje
        const displayId = ncData.numeroNC || ncData.id; 
        setErrorNC(`La NC (${displayId}) ya fue usada o no tiene saldo. Saldo: $${(ncData.montoRestante || 0).toFixed(2)}.`);
        return;
    }
    
    // Si es válida, la guardamos
    setNotaCreditoActiva(ncData);
    setErrorNC(null);

  }, []);

  // 💥 LOGICA NOTA DE CRÉDITO: useEffect para consulta automática
  useEffect(() => {
    if (ncIDIngresado && ncIDIngresado.length > 5) {
        consultarNotaCredito(ncIDIngresado);
    } else {
        setNotaCreditoActiva(null);
        setErrorNC(null);
    }
  }, [ncIDIngresado, consultarNotaCredito]);


  const handleFinalizar = async () => {
    if (carrito.length === 0) return alert("El carrito está vacío.");
    
    // ⭐️ NUEVA VALIDACIÓN: Debe haber al menos un pago si el total es mayor a cero
    if (totalFinal > 0.01 && pagos.length === 0) { // Tolerancia
        alert("Debes agregar al menos un método de pago.");
        return;
    }

    // ⭐️ NUEVA VALIDACIÓN: Saldo pendiente debe ser 0 para finalizar
    if (saldoPendienteAPagar > 0.01) { // Pequeña tolerancia para float
        alert(`Falta registrar pagos. Saldo pendiente: $${saldoPendienteAPagar.toFixed(2)}`);
        return;
    }


    const vendedorActivo = JSON.parse(localStorage.getItem("vendedorActivo"));
    if (!vendedorActivo) {
      alert("Debe seleccionar un vendedor antes de realizar ventas.");
      return;
    }

    setLoading(true);

    const ticketId = generarIDTicket();

    const ventaPayload = {
      ticketId,
      origenVenta: "Local",
      estadoPago: "Cobrado",  
      productos: carrito.map(it => ({
        idProducto: it.id,
        codigoProducto: it.codigoProducto,
        nombre: it.nombreProducto,
        categoria: it.categoria,    
        atributo: String(it.atributo || ""),            
        cantidad: it.cantidad,
        precioUnitario: Number(it.precioFinal || 0),
        subtotal: Number(it.precioFinal || 0) * it.cantidad,
        precioCosto: Number(it.precioCosto || 0),
        stockActual: Number(it.stock || 0)
      })),
      totalSinDescuento,
      descuentoAplicado,
      promoDescuento,
      motivoPromo,
      // ⭐️ Se registra el totalFinal (due)
      totalFinal, 
      // ⭐️ CAMBIO CLAVE: Registrar el array de pagos en lugar del método único
      pagos, 
      // Campo legacy para compatibilidad con ventas viejas, si solo hay un pago
      metodoPago: pagos.length === 1 ? pagos[0].metodo : "Combinado",
      cliente,
      estado,
      vendedor: {
        id: vendedorActivo.id,
        nombre: vendedorActivo.nombre
      },
      // 🔹 CAMPOS NC
      idNotaCreditoUsada: notaCreditoActiva ? notaCreditoActiva.id : null,
      numeroNotaCreditoUsada: notaCreditoActiva ? notaCreditoActiva.numeroNC || notaCreditoActiva.id : null, 
      montoCreditoUsado: montoNCUsado,
    };

    try {
      // 1. Registrar Venta
      const res = await registrarVenta(ventaPayload);
      if (!res.success) throw new Error("Error desconocido");
      
      // 💥 LOGICA NOTA DE CRÉDITO: Actualizar estado de la NC si fue usada
      if (notaCreditoActiva && montoNCUsado > 0) {
          const ncRef = doc(FIRESTORE_DB, "notasCredito", notaCreditoActiva.id);
          const nuevoMontoRestante = notaCreditoActiva.montoRestante - montoNCUsado;
          
          let nuevoEstadoNC;
          if (nuevoMontoRestante <= 0) {
              nuevoEstadoNC = 'usada'; // Usada completamente
          } else {
              nuevoEstadoNC = 'parcialmente_usada'; // Usada parcialmente
          }

          await updateDoc(ncRef, {
              montoRestante: nuevoMontoRestante,
              estado: nuevoEstadoNC,
              ventasDondeSeUso: arrayUnion({
                  idVenta: res.id,
                  montoAplicado: montoNCUsado,
                  fechaUso: new Date()
              })
          });
      }

      alert("Venta registrada: " + res.id);

      setTicketToPrint({
        ticketId,
        fecha: new Date(),
        productos: ventaPayload.productos,
        totalSinDescuento,
        descuentoAplicado,
        promoDescuento,
        motivoPromo,
        totalFinal,
        // ⭐️ CAMBIO: Pasar el array de pagos en lugar del método único
        pagos, 
        cliente,
        // ⭐️ Pasar la info de NC al ticket
        idNotaCreditoUsada: ventaPayload.idNotaCreditoUsada,
        numeroNotaCreditoUsada: ventaPayload.numeroNotaCreditoUsada, 
        montoCreditoUsado: ventaPayload.montoCreditoUsado,
      });

      await loadProductos();
      setCarrito([]);
    } catch (err) {
      console.error(err);
      alert("Error al finalizar la venta");
    }

    setLoading(false);
  };

  const focusBuscar = () => {
    if (buscadorRef.current) {
      buscadorRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  //funcion para recargar productos cuando se usa crear producto por MODAL
  const cerrarCrearProducto = async () => {
  await loadProductos();   // 👈 recarga desde Firestore
  setShowCrearProducto(false);
};
 

  return (
    <>
      <NavBarDashboard />

      <Container fluid className="py-4" style={{ background: "#f5f7fb", minHeight: "100vh" }}>
        <Row className="mb-3">
          <Col>
            <h3 className="text-primary">Venta al Público</h3>
            <p className="text-muted">POS — Seleccioná productos, elegí método(s) de pago y generá ticket.</p>
          </Col>
          <Button
  variant="outline-primary"
  className="mt-2"
  onClick={() => setShowCrearProducto(true)}
>
  + Crear producto
</Button>

        </Row>

        <Row className="mb-3">
          <Col>
            <Card className="shadow-sm border-0 p-3">
              <div ref={buscadorRef}>
                <BuscadorProductos
                  filtros={filtros}
                  setFiltros={setFiltros}
                  categorias={categorias}
                  proveedores={proveedores}
                  onClear={limpiarFiltros}
                />
              </div>
            </Card>
          </Col>
        </Row>

        <Row className="g-4">
          <Col xs={12} md={7}>
            <Card className="shadow-sm border-0">
              <Card.Body>
                <Card.Title>Productos disponibles</Card.Title>
                <Card.Subtitle className="text-muted small mb-3">
                  Lista con código, proveedor, stock, precio final y categoría
                </Card.Subtitle>
                <hr />

                <ListaProductos productos={productosFiltrados} onAgregar={agregarAlCarrito} />
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} md={5}>
            <Card
              className="shadow-sm border-0"
              style={{
                background: "#d8e9ff",
                borderRadius: "12px"
              }}
            >
              <Card.Body>
                <Card.Title>Carrito</Card.Title>
                <Card.Subtitle className="text-muted small mb-3">
                  Productos seleccionados
                </Card.Subtitle>

                <hr />

                <Carrito
                  carrito={carrito}
                  cambiarCantidad={cambiarCantidad}
                  quitarDelCarrito={quitarDelCarrito}
                  totalSinDescuento={totalSinDescuento}
                  gananciaBruta={gananciaBruta}
                />

                <hr />
                
                {/* 💥 SECCIÓN DE NOTA DE CRÉDITO */}
                <Row className="mb-3">
                    <Col>
                        <Card className="p-3 border-secondary" style={{ borderStyle: 'dashed' }}>
                            <Form.Group>
                                <Form.Label className="fw-bold">Aplicar Nota de Crédito (NC)</Form.Label>
                                <div className="d-flex gap-2">
                                    <Form.Control
                                        type="text"
                                        placeholder="Ingresar ID/N° de NC"
                                        value={ncIDIngresado}
                                        onChange={(e) => setNcIDIngresado(e.target.value)}
                                        disabled={carrito.length === 0}
                                    />
                                    {/* Botón para forzar la limpieza si la NC fue cargada */}
                                    {notaCreditoActiva && (
                                        <Button variant="outline-danger" onClick={() => {
                                            setNcIDIngresado("");
                                            setNotaCreditoActiva(null);
                                        }}>
                                            X
                                        </Button>
                                    )}
                                </div>
                            </Form.Group>
                            {/* Mensajes de estado */}
                            {errorNC && <Alert variant="danger" className="mt-2 p-2">{errorNC}</Alert>}
                            {notaCreditoActiva && (
                                <div className="mt-2">
                                    <Alert variant="success" className="p-2 m-0">
                                        <p className="m-0">
                                            NC Válida (
                                            N°: <strong>{notaCreditoActiva.numeroNC || notaCreditoActiva.id}</strong> | 
                                            Saldo: <strong>${notaCreditoActiva.montoRestante.toFixed(2)}</strong>
                                        </p>
                                        <p className="m-0 text-decoration-underline">
                                            Monto a aplicar en esta venta: <strong>${montoNCUsado.toFixed(2)}</strong>
                                        </p>
                                    </Alert>
                                </div>
                            )}
                        </Card>
                    </Col>
                </Row>
                {/* 💥 FIN SECCIÓN NOTA DE CRÉDITO */}

                <Button
  variant="outline-primary"
  className="mb-2"
  disabled={totalSinDescuento === 0}
  onClick={() => setShowCalcEfectivo(true)}
>
  Calculadora efectivo
</Button>


                <MetodoPago
                  // ⭐️ NUEVA PROP: Pasamos si se usó la Nota de Crédito
                  isNcUsed={isNcUsed} 
                  // ⭐️ CAMBIO CLAVE: Pasar el array de pagos y el total final a pagar
                  pagos={pagos}
                  setPagos={setPagos}
                  cliente={cliente}
                  setCliente={setCliente}
                  estado={estado}
                  setEstado={setEstado}
                  totalSinDescuento={totalSinDescuento}
                  descuentoAplicado={descuentoAplicado}
                  setDescuentoAplicado={setDescuentoAplicado}
                  promoDescuento={promoDescuento}
                  setPromoDescuento={setPromoDescuento}
                  motivoPromo={motivoPromo}
                  setMotivoPromo={setMotivoPromo}
                  totalFinalAPagar={totalFinal} // ⭐️ El monto que falta cubrir después de descuentos y NC
                />

                {/* ⭐️ INICIO NUEVA SECCIÓN: DETALLE DE DESCUENTOS Y SUB-TOTALES */}
                {/* Esto ayuda a clarificar cómo se llega al TOTAL VENTA (DUE) 
                  y resuelve la confusión de que no se ve el descuento aplicado.
                */}
                {(totalFinalBruto < totalSinDescuento || montoNCUsado > 0) && (
                    <div className="mt-3 pt-3 border-top border-secondary border-2">
                        
                        {/* 1. TOTAL SIN DESCUENTOS */}
                        {totalFinalBruto < totalSinDescuento && (
                            <div className="d-flex justify-content-between align-items-center">
                                <span className="fw-bold small text-muted">TOTAL BRUTO (Artículos)</span>
                                <span className="m-0 text-dark fw-bold small">
                                    ${totalSinDescuento.toFixed(2)}
                                </span>
                            </div>
                        )}
                        
                        {/* 2. Descuentos Aplicados */}
                        {(descuentoAplicado > 0 || promoDescuento > 0) && (
                            <>
                                {/* Descuento por Efectivo */}
                                {descuentoAplicado > 0 && (
                                     <div className="d-flex justify-content-between align-items-center mt-1">
                                        <span className="text-danger small">Descuento por Efectivo</span>
                                        <span className="m-0 text-danger fw-bold small">
                                            -${descuentoAplicado.toFixed(2)}
                                        </span>
                                    </div>
                                )}
                                
                                {/* Descuento por Promoción */}
                                {promoDescuento > 0 && (
                                     <div className="d-flex justify-content-between align-items-center mt-1">
                                        <span className="text-danger small">Desc. Promo ({promoDescuento}%)</span>
                                        <span className="m-0 text-danger fw-bold small">
                                            -${Math.round(totalSinDescuento * ((promoDescuento || 0) / 100)).toFixed(2)}
                                        </span>
                                    </div>
                                )}
                                
                                {/* Subtotal Neto (después de descuentos, antes de NC) */}
                                <div className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top border-dark border-1">
                                    <span className="fw-bold small">NETO A CUBRIR (Antes de NC)</span>
                                    <span className="m-0 text-dark fw-bold small">
                                        ${totalFinalBruto.toFixed(2)}
                                    </span>
                                </div>
                            </>
                        )}
                    </div>
                )}
                {/* ⭐️ FIN NUEVA SECCIÓN: DETALLE DE DESCUENTOS Y SUB-TOTALES */}


                {/* 💥 RESUMEN DE NC APLICADA */}
                {montoNCUsado > 0 && (
                     <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top border-secondary border-2">
                        <span className="text-info fw-bold">PAGO CON NOTA DE CRÉDITO</span>
                        <h5 className="m-0 text-info fw-bold">
                            -${montoNCUsado.toFixed(2)}
                        </h5>
                    </div>
                )}
                {/* 💥 FIN RESUMEN NC */}

                {/* 💥 TOTAL FINAL ACTUALIZADO (Monto DUE - lo que el cliente debe pagar) */}
                <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top border-dark border-3">
                    <span className="fw-bold">TOTAL VENTA (DUE)</span>
                    <h3 className="m-0 text-dark fw-bold">
                        ${totalFinal.toFixed(2)}
                    </h3>
                </div>

                {/* ⭐️ NUEVO: Monto Pagado por Métodos */}
                <div className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top">
                    <span className="fw-bold text-success">TOTAL PAGADO</span>
                    <h4 className="m-0 text-success fw-bold">
                        ${totalPagadoPorMetodos.toFixed(2)}
                    </h4>
                </div>
                
                {/* ⭐️ NUEVO: Saldo Pendiente */}
                {/* Utilizamos la tolerancia para asegurar que 0.00 no muestre un error */}
                {saldoPendienteAPagar > 0.01 && (
                    <div className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top border-danger border-2">
                        <span className="fw-bold text-danger">SALDO PENDIENTE</span>
                        <h4 className="m-0 text-danger fw-bold">
                            ${saldoPendienteAPagar.toFixed(2)}
                        </h4>
                    </div>
                )}


                <div className="mt-3 d-grid gap-2">
                  <Button 
                    variant="success" 
                    // ⭐️ Condición de desactivación: Saldo pendiente debe ser 0 para habilitar
                    onClick={handleFinalizar} 
                    disabled={loading || carrito.length === 0 || saldoPendienteAPagar > 0.01}
                  >
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Procesando...
                      </>
                    ) : (
                      "Finalizar venta (F2)"
                    )}
                  </Button>

                  <Button variant="outline-secondary" onClick={limpiarCarrito}>
                    Limpiar carrito
                  </Button>

                  {ticketToPrint && (
                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <div>
                        <strong>Último ticket:</strong> {ticketToPrint.ticketId}
                      </div>
                      <TicketA4 venta={{ ...ticketToPrint, fecha: new Date() }} />
                      <Ticket58mm venta={{ ...ticketToPrint, fecha: new Date() }} />
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <AtajosPOS
        onFocusBuscar={focusBuscar}
        onFinalizarVenta={handleFinalizar}
        onLimpiar={limpiarCarrito}
      />

      <FooterDashboard/>
<CrearProducto
  show={showCrearProducto}
  onClose={cerrarCrearProducto}
/>
<CalculadoraEfectivoModal
  show={showCalcEfectivo}
  onClose={() => setShowCalcEfectivo(false)}
  total={totalSinDescuento}
  onAplicar={(porcentaje) => setPromoDescuento(porcentaje)
    
  }

  
/>


    </>
  );
};

export { Ventas };